import { createComponentInstance } from '@/utils/mount-component'
import { inBrowser } from '@/utils'
import LoginModal from './LoginModal.vue'

let instance

const DEFAULT_OPTIONS = {
  source: 'unknown',
  redirect: null,
  callback: null,
}

let currentOptions = Object.assign({}, DEFAULT_OPTIONS)

function initInstance() {
  instance = createComponentInstance(LoginModal)
}

/**
 * 显示登录弹窗
 * @param {Object} options - 配置选项
 * @param {string} [options.source] - 来源标识（用于统计和调试）
 * @param {string} [options.redirect] - 登录后跳转路径
 * @param {Function} [options.callback] - 登录成功回调
 *
 * @example
 * import { showLoginModal } from '@/components/LoginModal'
 *
 * // 基础使用
 * showLoginModal({ source: 'home-page' })
 *
 * // 带重定向
 * showLoginModal({
 *   source: 'profile-page',
 *   redirect: '/user/profile'
 * })
 *
 * // 带回调
 * showLoginModal({
 *   source: 'checkout',
 *   callback: () => {
 *     console.log('Login successful')
 *   }
 * })
 */
export function showLoginModal(options = {}) {
  if (!inBrowser) {
    return
  }

  if (!instance) {
    initInstance()
  }

  const mergedOptions = Object.assign({}, currentOptions, options)
  // const originalCallback = mergedOptions.callback

  instance.open(
    Object.assign({}, mergedOptions, {
      onClose: () => {
        // 关闭时的逻辑（如果需要）
      },
      onClosed: () => {
        if (instance?.unmount) {
          instance.unmount()
          instance = null
        }
      },
    })
  )
}

/**
 * 关闭登录弹窗
 */
export function closeLoginModal() {
  if (instance) {
    instance.toggle(false)
  }
}
